'use client'

import { useLocale } from 'next-intl'
import { memo, useMemo } from 'react'

export interface NumberFormatProps extends Intl.NumberFormatOptions {
  value: number
}

const NumberFormat = memo(function NumberFormat(props: NumberFormatProps) {
  const { value, ...options } = props
  const locale = useLocale()

  const formattedValue = useMemo(() => {
    const formatter = new Intl.NumberFormat(locale, options)

    return formatter.format(value)
  }, [locale, options, value])

  return <>{formattedValue}</>
})

export default NumberFormat
